import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import dayjs from "dayjs"
import { useSearchProprietaries } from "../../hooks/useProprietary"

export const useExpiredProprietaryAlertCount = (token: string) => {
    const [count, setCount] = useState(0)
    const manualTypeQuery = "仮ブロック" //期限があるものは基本仮ブロックのみとしてロジックを組む
    // TODO: 設営の期限も通知に表示する。useSearchProprietariesを2回読んでdataをマージする
    const PAGE_SIZE = 100
    const [page] = useState(0)
    const { data, refetch } = useSearchProprietaries(token, {
        conditions: {
            manualTypeQuery,
            endDateSince: dayjs().format("YYYY-MM-DD")
        },
        pagination: { page, itemsPerPage: PAGE_SIZE },
        sortOrder: "later"
    })

    useEffect(() => {
        setCount(
            data?.proprietaries?.filter(r => {
                if (
                    r.expiration.expiredDateFlag === "expiration" &&
                    !dayjs().isBefore(dayjs(r.expiration.expiredDate), "d")
                ) {
                    return r
                }
                return null
            }).length ?? 0
        )
    }, [data])

    const location = useLocation()
    useEffect(() => {
        refetch()
        // useFetchへの引数を渡すときにメモ化を行っていないのでrefetchを加えてはいけない
        // ちゃんとやるならuseFetchへの引数もメモ化するべきだが、他のところでもやっておらず作業が広範囲に及ぶ割にメモ化しておいた方がいいケースが珍しいので一旦このままでもよいかなという気持ち
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return {
        count
    }
}
